import { Injectable } from '@angular/core';
import { PrroConfigService } from './prro-config.service';
import { ITaxConfig } from './tax-register-config.service';
import { TaxRegisterConfigService } from './tax-register-config.service';

@Injectable({
  providedIn: 'root',
})
export class TaxRegisterConfigAccessService {
  constructor(
    private manualConfigService: TaxRegisterConfigService,
    private prroConfigService: PrroConfigService,
  ) {}

  getManualConfigService(): TaxRegisterConfigService {
    return this.manualConfigService;
  }

  getPrroConfigService(): PrroConfigService {
    return this.prroConfigService;
  }

  // The server configs are loaded for the terminal store and include its departments,
  // so any of them means the server manages the PRRO (same rule as getConfig).
  async hasServerConfig(): Promise<boolean> {
    const serverConfigs = await this.prroConfigService.getConfig();
    return !!serverConfigs?.length;
  }

  // The server and manual configs read again from the storage (both are kept in memory).
  async reload(): Promise<void> {
    await Promise.all([this.prroConfigService.reload(), this.manualConfigService.reload()]);
  }

  async getConfig(): Promise<ITaxConfig[]> {
    const serverConfigs = await this.prroConfigService.getConfig();
    if (serverConfigs?.length) {
      return serverConfigs;
    }

    return this.manualConfigService.getConfig();
  }

  async getStoreConfig(storeId: number): Promise<ITaxConfig | undefined> {
    const serverConfig = await this.prroConfigService.getStoreConfig(storeId);
    if (serverConfig) {
      return serverConfig;
    }

    return this.manualConfigService.getStoreConfig(storeId);
  }

  async getRegisterConfig(
    taxRegisterFiscalNumber: string,
  ): Promise<ITaxConfig | undefined> {
    const serverConfig = await this.prroConfigService.getRegisterConfig(
      taxRegisterFiscalNumber,
    );
    if (serverConfig) {
      return serverConfig;
    }

    return this.manualConfigService.getRegisterConfig(taxRegisterFiscalNumber);
  }

  async updateTaxConfigs(companyId: string, storeId: number): Promise<void> {
    await Promise.all([
      this.prroConfigService.updateTaxConfigs(companyId, storeId),
      this.manualConfigService.updateTaxConfigs(companyId, storeId),
    ]);
  }
}
